import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import { HttpService } from '../services/http/http.service';
import { AuthService } from '../services/auth/auth.service';
@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})

export class WelcomeComponent implements OnInit{
  menuItems:any;
  contentTitle:string='';
  contentId:number=0;

  constructor(private router: Router, private auth: AuthService, private api: HttpService) {}
  
  ngOnInit(): void {
    // caricamento dinamico menu a sinistra

      this.api.getMenuHomePage().subscribe({
        next: (response:any) => {
         this.menuItems = response.result;
         this.contentTitle = this.menuItems[0].descrizione;
         this.contentId = this.menuItems[0].id;
         
      }
      })
  }

  // valorizzazione contenuto dinamico in pagina in base al click sul menu a sinistra
  loadContent(event:any) {
    this.contentTitle = event.descrizione;
    this.contentId = event.id
  }

  // funzione di login
  login() {
    window.location.href='secured/landing'
  }
}

